import { defineComponent, computed } from 'vue';
import OfferList from '~/components/constructor-components/offer-list/OfferList.vue';
import PromoCategorySlider from '~/components/promo/promo-category-slider/promo-category-slider.vue';
import PromoCodesList from '~/components/promo/promo-codes-list/promo-codes-list.vue';
import PromoPresets from '~/components/promo/promo-presets/promo-presets.vue';
import PromoCustomImageBanner from '~/components/promo/promo-custom-image-banner/promo-custom-image-banner.vue';
import PromoOfferList from '~/components/promo/promo-offer-list/promo-offer-list.vue';
import { useGlobalStore } from '~/stores/global';
import type { PromoPage } from '~/interfaces/api';

export default defineComponent({
  name: 'PromoSlug',
  components: {
    OfferList,
    PromoCategorySlider,
    PromoCodesList,
    PromoPresets,
    PromoOfferList,
    PromoCustomImageBanner,
  },
  props: {
    pageInfo: {
      type: Object as () => PromoPage,
      required: true,
    },
  },
  setup(props) {
    const { $ymAnyEventWithParam } = useNuxtApp();
    const globalStore = useGlobalStore();
    const whiteButtons = computed(() => {
      return props.pageInfo?.slug !== 'blogger-sad-i-kuhnya';
    });
    const CategoriesPopularData = computed(() => {
      const noLinkType = ['PromoCodesList', 'PromoBanner'];
      return props.pageInfo.blocks.reduce(
        (arr: { name: string; slug: string }[], item) => {
          if (noLinkType.includes(item.type) || item?.props?.id === 'beauty') {
            return arr;
          }
          arr.push({
            name: item?.props?.withHeader || item.props?.data?.title || '',
            slug: `#${item?.props?.id || item.props?.data?.id || ''}`,
          });
          return arr;
        },
        []
      );
    });
    const blocks = computed(() => {
      if (!props.pageInfo?.dataPages?.isPresets) return props.pageInfo.blocks;
      const [first, ...other] = props.pageInfo?.blocks;
      const addBlock = {
        type: 'PromoPresets',
        props: {
          list: CategoriesPopularData.value,
        },
      };
      return [first, addBlock, ...other];
    });

    const sendAnaliticsBannerClick = (number: number) => {
      $ymAnyEventWithParam('reachGoal', 'clickblack', { number });
    };

    useHead(() => {
      let title = props.pageInfo?.dataPages?.title || '';
      if (title && title.includes('city')) {
        title = title.replace('(%city%)', globalStore.region.name || 'Москвы');
      }
      return {
        title,
        meta: [
          {
            name: 'description',
            content: props.pageInfo?.dataPages?.description || '',
          },
          {
            property: 'og:title',
            content: `${props.pageInfo?.dataPages?.title || ''}`,
          },
          {
            property: 'og:description',
            content: `${props.pageInfo?.dataPages?.description || ''}`,
          },
        ],
        link: [
          {
            rel: 'icon',
            type: 'image/x-icon',
            href: '/favicon.ico',
            sizes: 'any',
          },
          { rel: 'icon', type: 'image/svg+xml', href: '/static/icon.svg' },
          { rel: 'apple-touch-icon', href: '/apple-touch-icon.png' },
          { rel: 'manifest', href: '/manifest.json' },
        ],
      };
    });

    return {
      sendAnaliticsBannerClick,
      blocks,
      whiteButtons,
    };
  },
});
